import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getDividends } from '../util/dividends';
import { DividendRecord } from '../types/hiro';

export const useDividends = <TData = DividendRecord[], TError = unknown>(
  {
    sym,
    start,
    end,
    excludeForecast,
  }: {
    sym: string;
    start?: string;
    end?: string;
    excludeForecast?: boolean;
  },
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<TData, TError>({
    queryKey: ['dividends', { sym, start, end, excludeForecast }],
    queryFn: async (): Promise<TData> => {
      return getDividends(sym, {
        start,
        end,
        excludeForecast,
      }) as Promise<TData>;
    },
    staleTime: 5 * 60 * 1_000, // 5 minutes
    ...options,
  });
};
